/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import React, { FC, useEffect, useState } from 'react';
import {
    SelectionMode,
    DetailsListLayoutMode,
    OverflowSet,
    CommandBarButton,
    IOverflowSetItemProps
} from '@fluentui/react';
import {
    Language,
    DetailsList,
    ColumnInfo,
    FilteredColumn,
    SortedColumnInfo,
    FilterType,
} from '@eta/components';
import { useTranslation } from 'react-i18next';
import './LinkedTaxpayerGrid.scss';
import { RepresentedTaxpayersResponseDto } from '../Service/proxy';
import ViewPermessions from './ViewPermessions';
import { UIHelpers } from '../../helpers/UIHelpers';

interface LinkedTaxpayerGridProps {
    currentLanguage: Language;
    pageSize: number;
    currentPage: number;
    totalPages: number | undefined;
    totalRecords: number | undefined;
    items: RepresentedTaxpayersResponseDto[] | undefined;
    onActionClick?: (
        action: string,
        item: RepresentedTaxpayersResponseDto
    ) => void;
    onPageChanged: (pageNum: number) => boolean;
    onNbItemPerPageChanged: (nbItemPerPage: number) => boolean;
    onChanged: (pageIndex: number, filteredColumn: FilteredColumn[], sortedColumn?: SortedColumnInfo) => boolean;
    loadingText?: string;
}

export const LinkedTaxpayerGrid: FC<LinkedTaxpayerGridProps> = (props: LinkedTaxpayerGridProps) => {

    const { t } = useTranslation(['intermediaries', 'common']);
    const [columns, setColumns] = useState<ColumnInfo[]>();
    const { currentLanguage: currentLanguageProps, items: itemsProps, onActionClick, onChanged,
        pageSize, currentPage, totalPages, totalRecords, onNbItemPerPageChanged,
        onPageChanged, loadingText } = props;

    const [currentLanguage, setCurrentLanguage] = useState<Language>(
        currentLanguageProps
    );

    const [items, setItems] = useState<RepresentedTaxpayersResponseDto[]>();
    const [showRepresentationDialog, setShowRepresentationDialog] = useState<boolean>(false);
    const [RepresentationId, setRepresentationId] = useState<number>(0);

    const onRenderItemStyles = {
        root: { padding: '10px' },
        menuIcon: { fontSize: '16px' },
    };
    const onRenderOverflowButtonStyles = {
        root: { padding: '10px' },
        menuIcon: { fontSize: '16px' },
    };
    const onRenderItem = ({ name, icon, onClick }: IOverflowSetItemProps): JSX.Element => {
        return (
            <CommandBarButton
                role="menuitem"
                aria-label={name}
                styles={onRenderItemStyles}
                iconProps={{ iconName: icon }}
                onClick={onClick}
            />
        );
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onRenderOverflowButton = (overflowItems?: any[]): JSX.Element => {
        return (
            <CommandBarButton
                role="menuitem"
                title="More items"
                styles={onRenderOverflowButtonStyles}
                menuIconProps={{ iconName: 'MoreVertical' }}
                menuProps={{ items: overflowItems ?? [] }}
            />
        );
    };
    const onViewDetails=async (data: RepresentedTaxpayersResponseDto)=>{
        setShowRepresentationDialog(true);
        setRepresentationId(data.id??0);
     };
    useEffect(() => {
        setItems(itemsProps?.slice());
    }, [itemsProps]);

    useEffect(() => {
        if (currentLanguage.lang !== currentLanguageProps.lang) {
            setCurrentLanguage(currentLanguageProps);

            setItems(itemsProps?.slice());
        }
    }, [currentLanguageProps, itemsProps, currentLanguage]);

    useEffect(() => {
        const gridColumns = [
            {
                key: 'namePrimaryLang',
                name: t('LinkedTaxpayer.Name'),
                fieldName: 'namePrimaryLang',
                minWidth: 250,
                maxWidth: 250,
                isResizable: true,
                isSortedDescending: true,
                filterOption: {
                    placeholder: '',
                    type: FilterType.Text,
                    fieldNames: [
                        {
                            fieldName: 'namePrimaryLang',
                            displayName: t('LinkedTaxpayer.Name'),
                        }
                    ]
                },
                onRender: (item: RepresentedTaxpayersResponseDto) => {
                    return (
                        <span>{item.namePrimaryLang}</span>
                    );
                },
            },
            {
                key: 'nameSecondaryLang',
                name: t('LinkedTaxpayer.Name[AR]'),
                fieldName: 'nameSecondaryLang',
                filterOption: {
                    placeholder: '',
                    type: FilterType.Text,
                    fieldNames: [
                        {
                            fieldName: 'nameSecondaryLang',
                            displayName: t('LinkedTaxpayer.Name[AR]'),
                        }
                    ]
                },
                minWidth: 250,
                maxWidth: 250,
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: RepresentedTaxpayersResponseDto) => {
                    return (
                        <span>{item.nameSecondaryLang}</span>
                    );
                },
            },
            {
                key: 'activeFromTo',
                name: t('LinkedTaxpayer.RepresentationFromTo'),
                fieldName: 'activeFromTo',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: RepresentedTaxpayersResponseDto) => {
                    return (
                        <>
                          <span>{UIHelpers.getLocalizedDateTime('Date', item.activeFrom, currentLanguageProps.lang)}</span>
                          -
                          <span>{UIHelpers.getLocalizedDateTime('Date', item.activeTo, currentLanguageProps.lang)}</span>
                      </>                    
                    );
                },
            },
            
            {
                key: 'isActive',
                name: t('LinkedTaxpayer.RepresentationStatus'),
                fieldName: 'isActive',
                minWidth: 150,
                maxWidth: 150,
                isRowHeader: true,
                isResizable: false,
                onRender: (item: RepresentedTaxpayersResponseDto) => {
                    return (
                        <span className={item.isActive ? 'green' : 'red'}>{item.isActive ? t('Active') : t('Inactive')}</span>
                    );
                },
            },
            {
                key: 'action',
                name: '',
                minWidth: 40,
                maxWidth: 40,
                isResizable: false,
                data: 'string',
                isPadded: true,
                onRender: (data: RepresentedTaxpayersResponseDto) => {
                    return (
                      
                                    <div>
                                        <OverflowSet
                                            role="menubar"
                                            vertical
                                            overflowItems={[
                                                {
                                                    key: 'viewButton',
                                                    
                                                    name: t('view'),
                                                    onClick: () => {
                                                        onViewDetails(data);
                                                    },
                                                },
                                                
                                            ]}
                                            onRenderOverflowButton={
                                                onRenderOverflowButton
                                            }
                                            onRenderItem={onRenderItem}
                                        />
                                    </div>
                                
                            );
                },
            },
        ];
        setColumns(gridColumns);
    }, [currentLanguageProps, onActionClick, t]);

    return (
        <>
            <DetailsList
                className="grid"
                columns={columns ?? []}
                items={items}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
                loadingMessage={loadingText}
                noItemsPlaceholder={<span>{t('common:NoRecords')} </span>}
                labels={{ resultPerPage: t('common:nbItemPerPage'), totalRecord: t('common:totalRecord') }}
                onChanged={(pageIndex: number, filteredColumn: FilteredColumn[], sortedColumn?: SortedColumnInfo) => onChanged(pageIndex, filteredColumn, sortedColumn)}
                paginationSetting={{
                    nbItemPerPage: pageSize,
                    nbPageShown: 5,
                    currentPage: currentPage - 1,
                    totalPage: totalPages,
                }}
                onPageChanged={(pageIndex: number) => onPageChanged(pageIndex)}
                totalItemCount={totalRecords}
                onNbItemPerPageChanged={onNbItemPerPageChanged}
            />
            {showRepresentationDialog && (
            <ViewPermessions
                hidden={!showRepresentationDialog}
                onClose={() => setShowRepresentationDialog(false)}
                RepresentationId={RepresentationId}
                propsCurrentLanguage={currentLanguage}
                 />
        )}
        </>
    );
};
